// import React, { useEffect } from 'react';
// import logo from './logo.svg';
import './App.css';
import './component/css/home.css';
import './component/css/navbar.css';
import './component/css/about.css';
import Routeing from './component/Routeing';
import pic from "../src/component/images/logo/whatsapp_logoName.png"
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import { companyName, phnnumber } from './component/data/personalData';
import callIcon from './component/images/logo/call_icon.png';

function App() {

  return (
    <div >
      <Routeing />

      {/* ----------this is the call contact---------- */}

      <a href={`tel:${phnnumber}`} >
        <div className='call-icon-div call-style  floating-whatsapp-button'>
          <img src={callIcon} alt='call' />
        </div>
      </a>

      {/* ----------this is the whatsapp contact---------- */}

      <FloatingWhatsApp
        phoneNumber="+91 8146919479"
        accountName={companyName}
        chatMessage="Hello! we are here to help you.."
        avatar={pic}
        darkMode={false}
        placeholder='Type a message...'
        statusMessage="Replies within a few minutes"
        allowClickAway={true}
        allowEsc={true}
        styles={{
          zIndex: 1000,
        }}
      />
    </div>
  );
}

export default App;
